import { api } from '@/scripts/api';

export const FormService = {
    get(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Forms';

            const getFormsEndpoint = api.applyODataParams(service, {
                ...config,
                filter: `Id eq ${ id }`,
            });

            api.get(getFormsEndpoint)
                .then(resolve)
                .catch(reject);
        });

    },

    getAll(config = {}, signal) {
        return new Promise((resolve, reject) => {
            const service = '/service/Forms';

            const getFormsEndpoint = api.applyODataParams(service, config);

            api.get(getFormsEndpoint, signal)
                .then(resolve)
                .catch((error)=>{
                    if (!api.isCanceled(error)) {
                        reject(error);
                    }
                });
        });

    },

    post(payload) {
        return new Promise((resolve, reject) => {

            const service = '/api/Forms';

            api.post(service, payload)
                .then(resolve)
                .catch(reject);

        });
    },

    patch(id, payload) {
        return new Promise((resolve, reject) => {
            const service = `/api/Forms/${ id }`;

            api
                .patch(service, payload)
                .then(resolve)
                .catch(reject);
        });

    },

    delete(id) {
        return new Promise((resolve, reject) => {

            const service = `/api/Forms/${ id }`;

            api
                .delete(service)
                .then(resolve)
                .catch(reject);
        });
    },

    deleteAll(ids) {
        return new Promise((resolve, reject) => {

            const service = '/api/Forms/';

            api
                .delete(service, ids)
                .then(resolve)
                .catch(reject);
        });
    },

    addToMyForms(accountId, id) {
        return new Promise((resolve, reject) => {
            const service = `/api/Accounts/${accountId}/Forms/${id}/Add`;

            api
                .post(service)
                .then(resolve)
                .catch(reject)
        })
    },

    
    bulkAutoPublishForm(payload) {
        return new Promise((resolve, reject) => {
            api
                .post('/api/Forms/AutoPublish', payload)
                .then(resolve)
                .catch(reject)
        })
    },

    bulkAddCategoriesToForm(payload) {
        return new Promise((resolve, reject) => {
            api
                .post('/api/Forms/BulkAddCategory', payload)
                .then(resolve)
                .catch(reject)
        })
    },

    publish(id, clientIds) {
        return new Promise((resolve, reject) => {
            const service = `/api/Forms/${ id }/Publish`;

            api
                .post(service, clientIds)
                .then(resolve)
                .catch(reject);
        });

    },

    unpublish(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/Forms/${ id }/Publish`;

            api
                .post(service, [])
                .then(resolve)
                .catch(reject);
        });
    },

    getSharedAssets(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/SharedAssets';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `FormId eq ${ id }`,
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },

    getClient(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Clients';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `Id eq ${ id }`,
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },

    getClients(config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Clients';

            const endpoint = api.applyODataParams(service, config);

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },
}
